/* eslint-disable vue/no-unused-vars */
<template>
  <div class="subscribers">
    <a-card :loading="dashLoading" style="margin-bottom:1rem" class="card">
      <div slot="title">
        <a-button
          @click="backButton()"
          type="primary"
          size="small"
          icon="left"
          shape="circle"
          class="back-button"
        />&nbsp; <a-icon type="tags" style="margin-right:5px; font-size:22px" />
        <span class="main-card-title">Suscripciones</span>
      </div>
      <h3>
        <strong>Suscripciones activas:</strong>
        {{ dash.activeSubscriptions }}
      </h3>
      <!--
      <a-collapse :bordered="false">
        <a-collapse-panel header="MÁS DETALLES" key="1">
          
          <div :class="$style.optionTitle">Precio:</div>
          <div :class="$style.option">
            <a-input
              :defaultValue="this.subscription.amount"
              style="width:110px"
              size="small"
              ><span slot="prefix">$</span>
            </a-input>
          </div>

        </a-collapse-panel>
      </a-collapse>
      -->
      <router-link :to="{ name: 'subscriptionDetailsAdd' }"
        ><a-button type="primary" size="small" style="padding-top:2px">
          <!--<a-icon type="like" style="margin-right:0.5em" />-->Nueva
          Suscripción
        </a-button></router-link
      >
    </a-card>

    <a-card
      :headStyle="{ marginBottom: '0', paddingBottom: '0', minHeight: '40px' }"
      :bodyStyle="{ paddingTop: '3px' }"
      class="card"
    >
      <div slot="title">
        <a-input-search
          placeholder="Buscar..."
          style="width: 200px"
          @search="onSearch"
        />
      </div>
      <div slot="extra" class="extraStyle">
        <a-dropdown placement="bottomCenter" style="margin-right:1rem">
          <a class="ant-dropdown-link">
            Ordenar por: {{ orderBySelection }} <a-icon type="down"
          /></a>
          <a-menu slot="overlay" @click="handleOrderByClick">
            <a-menu-item key="id">Id</a-menu-item>
            <a-menu-item key="name">Título</a-menu-item>
            <a-menu-item key="amount">Precio</a-menu-item>
            <a-menu-item key="status">Estado</a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-dropdown placement="bottomCenter">
          <a class="ant-dropdown-link">
            Estado: {{ statusFilterSelection }} <a-icon type="down"
          /></a>
          <a-menu slot="overlay" @click="handleStatusFilterClick">
            <a-menu-item key="0">Todos</a-menu-item>
            <a-menu-item key="1">Activo</a-menu-item>
            <a-menu-item key="2">Inactivo</a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
      <div v-if="displayEmptyMessage" style="margin-top:2rem">
        <h5 style="color:#555;">No se registran suscripciones.</h5>
      </div>
      <div
        class="demo-infinite-container"
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="scrollDisabled"
        :infinite-scroll-distance="15"
        infinite-scroll-event-target="window"
      >
        <a-list :dataSource="listData" size="large">
          <a-list-item slot="renderItem" slot-scope="item" key="item.id">
            <a-list-item-meta>
              <div
                v-if="item.status == '1'"
                slot="avatar"
                :class="$style.avatarDiv"
              >
                <div :class="$style.avatarWithId">
                  <a-avatar :class="$style.green" icon="tag" />
                </div>
                <span :class="[$style.idBox, $style.green]"
                  >#{{ item.id }}
                </span>
              </div>
              <div v-else slot="avatar" :class="$style.avatarDiv">
                <div :class="$style.avatarWithId">
                  <a-avatar :class="$style.pink" icon="tag" />
                </div>
                <span :class="[$style.idBox, $style.pink]"
                  >#{{ item.id }}
                </span>
              </div>

              <h4 slot="title" @click="onRowClick(item.id)">
                <span v-if="orderBySelection == 'Título'">
                  <span style="color:black"> {{ item.name }} </span>
                  <span v-if="item.status == '1'">
                    <a-tag color="green">Activa</a-tag>
                  </span>
                  <span v-else>
                    <a-tag color="pink">Inactiva</a-tag>
                  </span>
                </span>
                <span v-else
                  >{{ item.name }}&nbsp;
                  <span v-if="item.status == '1'">
                    <a-tag color="green">Activa</a-tag>
                  </span>
                  <span v-else>
                    <a-tag color="pink">Inactiva</a-tag>
                  </span>
                </span>
              </h4>
              <div slot="description">
                <strong v-if="orderBySelection == 'Precio'" style="color:black">
                  Precio:
                  {{
                    new Intl.NumberFormat("es-AR", {
                      style: "currency",
                      currency: "ARS"
                    }).format(item.amount)
                  }}
                </strong>
                <span v-else>
                  Precio:
                  {{
                    new Intl.NumberFormat("es-AR", {
                      style: "currency",
                      currency: "ARS"
                    }).format(item.amount)
                  }} </span
                >&nbsp;&nbsp;|&nbsp;&nbsp;<a-icon type="user" />
                {{ item.activeSubscribers }}

                <!--
                <i class="icmn-whatsapp" />&nbsp;{{ item["costCenters.name"] }}
                <br />
                <strong
                  v-if="orderBySelection == 'businessUnit'"
                  style="color:black"
                >
                  {{ item["businessUnits.name"] }}</strong
                >
                <span v-else>
                  {{ item["businessUnits.name"] }}
                </span>
                -->
              </div>
            </a-list-item-meta>

            <template slot="actions">
              <a @click="onRowClick(item.id)"><a-icon type="eye" /> Detalle</a>
            </template>
            <!--
            <a-button>Content</a-button>
            -->
            <!--
            <a slot="actions"
              ><i class="icmn-user-minus" /> Finalizar Suscripción</a
            >
            <a slot="actions"><i class="icmn-coin-dollar" /> Cobro Manual</a>
-->
            <!--
            <template slot="actions" v-for="{ type, text } in actions">
              <a :key="type"><i :class="type" /> {{ text }}</a>
            </template>
            -->
          </a-list-item>

          <a-skeleton
            :loading="loadingData"
            :paragraph="{ rows: 1, width: '100%' }"
            active
            :title="false"
            style="margin-top:2rem"
          />
          <a-skeleton
            :loading="loadingData"
            :paragraph="{ rows: 1, width: '100%' }"
            active
            :title="false"
          />
          <a-skeleton
            :loading="loadingData"
            :paragraph="{ rows: 1, width: '100%' }"
            active
            :title="false"
          />
        </a-list>
      </div>
    </a-card>
  </div>
</template>
<!--
<template>
  <div>
    <a-card :loading="loadingData">
      <a-list :dataSource="listData">
        <virtual-scroller
          style="height: 400px"
          :items="listData"
          item-height="73"
          v-infinite-scroll="loadMore"
          :infinite-scroll-disabled="busy"
          :infinite-scroll-distance="10"
        >
        <a-list-item slot-scope="{ item }">
          <a-list-item-meta :description="item.paymentCard.customer.firstName">
            <a slot="title">
              {{ item.paymentCard.customer.firstName }}
              {{ item.paymentCard.customer.lastName }}
            </a>
            <a-avatar
              slot="avatar"
              src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
            />
          </a-list-item-meta>
          <div># {{ item.index }}</div>
        </a-list-item>
        </virtual-scroller>
        <a-spin v-if="loading" class="demo-loading" />
      </a-list>
    </a-card>
  </div>
</template>
-->
<script>
//import { data } from "./data.json";
import { mapActions } from "vuex";
import store from "@/store";
import infiniteScroll from "@/services/vue-infinite-scroll";
//import { RecycleScroller } from "vue-virtual-scroller";

export default {
  name: "subscriptionsList", //necesita tener un name para que funcione el <keep-alive>
  directives: { infiniteScroll },
  /*components: {
    "virtual-scroller": RecycleScroller
  },*/
  data() {
    return {
      pagination: {
        position: "bottom"
      },
      loadingData: false,
      scrollDisabled: false,
      displayEmptyMessage: false,
      listData: [],
      statusFilterSelection: "Todos",
      orderBySelection: "Id",
      actions: [
        //{ type: "icmn-user-minus", text: "Realizar Baja" },
        //{ type: "icmn-coin-dollar", text: "Cobro Manual" },
        { type: "icmn-credit-card", text: "Forma de Pago" }
      ],
      dash: {
        activeSubscriptions: null
      },
      dashLoading: false
    };
  },
  props: ["subscriptionId"],
  methods: {
    ...mapActions({
      loadSubscriptions: "subscriptions/load",
      loadSubscriptionsDash: "subscriptions/loadDash"
    }),
    async fetchListData() {
      try {
        //console.log("params:", params);
        if (!this.loadingData) {
          this.loadingData = true;
          this.displayEmptyMessage = false;
          const result = await this.loadSubscriptions();
          if (store.state.subscriptions.results.length > 0) {
            this.listData = this.listData.concat(
              store.state.subscriptions.results
            ); //add results to existing results
          } else this.displayEmptyMessage = true;
          this.loadingData = false;
        }
      } catch (error) {
        this.loadingData = false;
        if (error.status == 404) this.displayEmptyMessage = true;
        else {
          this.$notification["warning"]({
            message: error.code,
            description: error.message
          });
        }
      }
    },
    async fetchDashboardData() {
      try {
        //console.log("params:", params);

        this.dashLoading = true;
        const result = await this.loadSubscriptionsDash();
        this.dash = store.state.subscriptions.dash;
        this.dashLoading = false;
      } catch (error) {
        this.dashLoading = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    },
    async loadMore() {
      try {
        if (
          //todavia hay registros para bajar
          this.$store.state.subscriptions.totalResults >
          this.$store.state.subscriptions.page *
            this.$store.state.subscriptions.pageSize
        ) {
          this.scrollDisabled = true;
          this.$nprogress.start();
          const result = await this.fetchListData();
          this.scrollDisabled = false;
          this.$nprogress.done();
        }
        return;
      } catch (error) {
        this.scrollDisabled = false;
        this.$nprogress.done();
        this.$notification["failure"]({
          message: "Error",
          description: `Hubo un error al cargar el listado. Disabled: ${this.scrollDisabled}`
        });
      }
    },
    handleStatusFilterClick(event) {
      this.statusFilterSelection = event.item.$el.innerHTML;
      this.$store.commit("subscriptions/SET_STATUS_ID", event.key);
      this.$store.commit("subscriptions/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      //this.loadMore();
      this.fetchListData(true);
    },
    handleOrderByClick(event) {
      this.orderBySelection = event.item.$el.innerHTML;
      this.$store.commit("subscriptions/SET_ORDER_BY", event.key);
      this.$store.commit("subscriptions/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      //this.loadMore();
      this.fetchListData(true);
    },
    onSearch(keyword) {
      this.$store.commit("subscriptions/SET_SEARCH", keyword);
      this.$store.commit("subscriptions/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      //this.loadMore();
      this.fetchListData(true);
    },
    onRowClick(id) {
      this.$emit("subscriptionClick", id);
      this.$router.push(`/subscriptions/${id}`);
    }
    /*
    async addRecord() {
      try {
        const newData = [...this.tableData];
        const target = newData.filter(item => "+" === item.id)[0];
        if (target) {
          console.log("params:", params);
          this.loading = true;
          const params = {
            name: target.name,
            amount: target.amount,
            frequencyId: target.frequencyId,
            endDate: target.endDate,
            freeTrialDays: target.freeTrialDays,
            costCenterId: target.costCenter.id,
            businessUnitId: target.businessUnit.id
          };
          const result = await this.addSubscription(params);
          delete target.editable;
          delete target.add;
          const result2 = await this.fetchTableData();
        }
      } catch (error) {
        this.loading = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    },
    async saveRecord(key) {
      try {
        const newData = [...this.tableData];
        const target = newData.filter(item => key === item.id)[0];
        if (target) {
          //console.log("params:", params);
          this.loading = true;
          const params = {
            id: target.id,
            name: target.name,
            amount: target.amount,
            frequencyId: target.frequencyId,
            endDate: target.endDate,
            freeTrialDays: target.freeTrialDays,
            costCenterId: target.costCenter.id,
            businessUnitId: target.businessUnit.id,
            status: target.status
          };
          const result = await this.saveSubscription(params);
          this.tableData = newData;
          delete target.editable;
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
        this.$notification["warning"]({
          //NOTA IMPORTANTE: el debugger de chrome no muestra el error object pero llega.
          message: error.response.status,
          description: error.response.data.data[0]
        });
      }
    },
    async deleteRecord(key) {
      try {
        const newData = [...this.tableData];
        const target = newData.filter(item => key === item.id)[0];
        if (target) {
          this.loading = true;
          const result = await this.deleteSubscription(key);
          this.tableData = newData.filter(item => item.id !== key);
          this.loading = false;
        }
      } catch (error) {
        //this.$nprogress.done();
        this.loading = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    }*/
  },
  created() {
    //window.addEventListener("touchmove", this.loadMore);
  },
  mounted() {
    this.$store.commit("subscriptions/SET_RESET_PAGE");
    this.fetchListData();
    this.fetchDashboardData();
  },
  activated() {
    //it's run when actived in keep-alive mode
    if (this.$store.state.subscriptions.listUpdated) {
      this.listData = [];
      this.$store.commit("subscriptions/SET_RESET_PAGE");
      this.$store.commit("subscriptions/SET_LIST_UPDATED", false);
      this.fetchListData();
      this.fetchDashboardData();
    }
  }
};
</script>

<style lang="scss" module>
@import "./index.module.scss";
.editable-row-operations a {
  margin-right: 8px;
}
</style>

<style lang="css">
.demo-loading-container {
  position: absolute;
  bottom: 50%;
  width: 100%;
  text-align: center;
}
.ant-list-item-action {
  margin-top: 1rem;
}
.ant-dropdown-link {
  text-transform: none;
  font-weight: normal;
}
.ant-card-head {
  min-height: 44px;
}
.ant-card-head-wrapper {
  flex-direction: row;
}
.ant-card-extra,
.ant-card-head-title {
  padding-top: 13px;
  padding-bottom: 9px;
}
.ant-card-body {
  padding: 17px 32px;
}
.ant-tag {
  vertical-align: middle;
}
.back-button {
  vertical-align: 0.38rem;
}
strong {
  color: #000;
  font-weight: 700;
}
h4:hover {
  color: #0190fe;
  cursor: pointer;
}
.anticon {
  vertical-align: -0.2rem;
}
.ant-tag {
  vertical-align: 0.2rem;
}
</style>
